import { render, staticRenderFns } from "./PostPurchaseSteps.vue?vue&type=template&id=014736c3"
import script from "./PostPurchaseSteps.vue?vue&type=script&lang=js"
export * from "./PostPurchaseSteps.vue?vue&type=script&lang=js"
import style0 from "../assets/postPurchase.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports